import { unified as j } from "unified";
import B from "remark-parse";
import z from "remark-directive";
import { isTitlelessDivisionType as ie, divisionTypeAtRelativeDepth as se, isTopLevelDivisionType as le } from "@pretextbook/ptxast";
import { visit as W } from "unist-util-visit";
const S = {
  // theorem-like (requires statement wrapping)
  theorem: { type: "theorem", category: "theorem-like", requiresStatement: !0 },
  lemma: { type: "lemma", category: "theorem-like", requiresStatement: !0 },
  corollary: { type: "corollary", category: "theorem-like", requiresStatement: !0 },
  proposition: { type: "proposition", category: "theorem-like", requiresStatement: !0 },
  claim: { type: "claim", category: "theorem-like", requiresStatement: !0 },
  fact: { type: "fact", category: "theorem-like", requiresStatement: !0 },
  conjecture: { type: "conjecture", category: "theorem-like", requiresStatement: !0 },
  axiom: { type: "axiom", category: "theorem-like", requiresStatement: !0 },
  principle: { type: "principle", category: "theorem-like", requiresStatement: !0 },
  hypothesis: { type: "hypothesis", category: "theorem-like", requiresStatement: !0 },
  algorithm: { type: "algorithm", category: "theorem-like", requiresStatement: !0 },
  // definition-like (requires statement wrapping)
  definition: { type: "definition", category: "definition-like", requiresStatement: !0 },
  notation: { type: "notation", category: "definition-like", requiresStatement: !0 },
  // remark-like (no statement wrapping)
  remark: { type: "remark", category: "remark-like", requiresStatement: !1 },
  note: { type: "note", category: "remark-like", requiresStatement: !1 },
  observation: { type: "observation", category: "remark-like", requiresStatement: !1 },
  warning: { type: "warning", category: "remark-like", requiresStatement: !1 },
  insight: { type: "insight", category: "remark-like", requiresStatement: !1 },
  assemblage: { type: "assemblage", category: "remark-like", requiresStatement: !1 },
  // example-like (exercise/project/task support nested tasks; require statement if no nested tasks)
  example: { type: "example", category: "example-like", requiresStatement: !1 },
  question: { type: "question", category: "example-like", requiresStatement: !1 },
  problem: { type: "problem", category: "example-like", requiresStatement: !1 },
  exercise: { type: "exercise", category: "example-like", requiresStatement: !0, hasNestedTasks: !0 },
  activity: { type: "activity", category: "example-like", requiresStatement: !1 },
  exploration: { type: "exploration", category: "example-like", requiresStatement: !1 },
  investigation: { type: "investigation", category: "example-like", requiresStatement: !1 },
  project: { type: "project", category: "example-like", requiresStatement: !0, hasNestedTasks: !0 },
  // task (can have nested tasks, requires statement if no nested tasks)
  task: { type: "task", category: "example-like", requiresStatement: !0, hasNestedTasks: !0 },
  // proof-like (no statement wrapping)
  proof: { type: "proof", category: "proof-like", requiresStatement: !1 },
  case: { type: "case", category: "proof-like", requiresStatement: !1 },
  // solution-like (no statement wrapping)
  solution: { type: "solution", category: "solution-like", requiresStatement: !1 },
  hint: { type: "hint", category: "solution-like", requiresStatement: !1 },
  answer: { type: "answer", category: "solution-like", requiresStatement: !1 }
}, St = S;
function ce(e) {
  return S[e.toLowerCase()];
}
const H = new Set(
  Object.entries(S).filter(([e, t]) => t.category === "proof-like" || t.category === "solution-like").map(([e]) => e)
);
function b(e, t, n) {
  return {
    type: "element",
    name: e,
    attributes: n ?? {},
    children: t
  };
}
function D(e) {
  return e.type === "containerDirective" && e.name === "task";
}
function ae(e) {
  return e.type === "containerDirective" && H.has(e.name);
}
function w(e) {
  const t = [];
  for (const n of e)
    n.name === "ul" || n.name === "ol" ? t.length > 0 && t[t.length - 1]?.name === "p" ? t[t.length - 1].children.push(n) : t.push(b("p", [n])) : t.push(n);
  return t;
}
function ue(e, t, n, o, r, i, s) {
  const l = [];
  if (n && l.push(n), e.hasNestedTasks) {
    const c = o.findIndex(D);
    if (c !== -1) {
      const a = [];
      for (let p = 0; p < o.length; p++)
        D(o[p]) && a.push(p);
      const u = a[a.length - 1], d = o.slice(0, c), m = o.slice(c).filter(D), k = [], y = [], F = [];
      for (let p = c; p < o.length; p++) {
        const f = o[p];
        if (!D(f)) {
          if (p < u) {
            k.push(f);
            continue;
          }
          if (ae(f)) {
            F.push(f);
            continue;
          }
          y.push(f);
        }
      }
      if (k.length > 0 && (r.messages ?? (r.messages = [])).push({
        type: "warning",
        reason: `Dropped ${k.length} non-task node(s) between task directives in ${e.type}.`,
        category: "dropped-content-between-tasks",
        position: k[0].position?.start
      }), d.length > 0) {
        const p = w(
          d.map((f) => i(f, r)).filter((f) => f !== null)
        );
        p.length > 0 && l.push(b("introduction", p));
      }
      for (const p of m) {
        const f = s(p, r);
        f && l.push(f);
      }
      if (y.length > 0) {
        const p = w(
          y.map((f) => i(f, r)).filter((f) => f !== null)
        );
        p.length > 0 && l.push(b("conclusion", p));
      }
      for (const p of F) {
        const f = s(p, r);
        f && l.push(f);
      }
    } else
      N(l, e, o, r, i, s);
  } else
    N(l, e, o, r, i, s);
  return b(e.type, l, t);
}
function N(e, t, n, o, r, i) {
  if (t.requiresStatement) {
    const s = [], l = [];
    for (const c of n)
      if (c.type === "containerDirective" && H.has(c.name)) {
        const a = i(c, o);
        a && l.push(a);
      } else
        s.push(c);
    if (s.length > 0) {
      const c = w(
        s.map((a) => r(a, o)).filter((a) => a !== null)
      );
      c.length > 0 && e.push(b("statement", c));
    }
    e.push(...l);
  } else {
    const s = w(
      n.map((l) => r(l, o)).filter((l) => l !== null)
    );
    e.push(...s);
  }
}
function U(e) {
  return { type: "text", value: e };
}
function h(e, t, n) {
  return {
    type: "element",
    name: e,
    attributes: n ?? {},
    children: t
  };
}
function g(e, t, n) {
  return h(e, [U(t)], n);
}
function Z(e) {
  return { type: "comment", value: e.replace(/--/g, "- -") };
}
function $(e, t) {
  const n = e?.position, o = n?.start?.offset, r = n?.end?.offset;
  return t.source && o != null && r != null ? t.source.slice(o, r) : "";
}
function X(e, t, n) {
  return h("TODO", [Z(`todo: ${t}`), g("pre", n)], {
    type: e
  });
}
function pe(e, t, n) {
  return h("TODO", [Z(`todo: ${t}`), g("c", n)], {
    type: e
  });
}
function M(e) {
  const t = [];
  for (const n of e)
    n.name === "ul" || n.name === "ol" ? t.length > 0 && t[t.length - 1]?.name === "p" ? t[t.length - 1].children.push(n) : t.push(h("p", [n])) : t.push(n);
  return t;
}
function O(e, t, n) {
  return fe(e, t, n).tree;
}
function fe(e, t, n) {
  const o = [], r = {
    ancestors: [],
    depth: 0,
    messages: o,
    source: t,
    topLevelDivision: n?.topLevelDivision ?? "chapter",
    topLevelAttributes: n?.topLevelAttributes,
    topLevelAttributesApplied: n?.topLevelAttributes ? { done: !1 } : void 0
  }, i = e.children;
  if (ie(r.topLevelDivision)) {
    const l = V(r), c = M(
      q(i, { ...r, depth: 1 }, !0)
    );
    return { tree: { type: "root", children: [h(r.topLevelDivision, c, l)] }, messages: o };
  }
  return {
    tree: { type: "root", children: q(i, r) },
    messages: o
  };
}
function q(e, t, n = !1) {
  let o = 7;
  for (const a of e)
    a.type === "heading" && (o = Math.min(o, a.depth));
  if (o === 7)
    return C(e, t, n);
  const r = [];
  let i = null, s = [], l = [];
  const c = () => {
    i && (r.push(he(i, l, t)), i = null, l = []);
  };
  for (const a of e)
    a.type === "heading" && a.depth === o ? (!i && s.length > 0 && (r.push(
      ...C(s, t, n)
    ), s = []), c(), i = a, l = []) : i ? l.push(a) : s.push(a);
  return !i && s.length > 0 && r.push(
    ...C(s, t, n)
  ), c(), r;
}
function C(e, t, n = !1) {
  const o = [];
  for (let r = 0; r < e.length; r += 1) {
    const i = e[r], s = E(i, t);
    if (s !== null) {
      if (s.name === "p" && s.children.length === 1 && s.children[0].name === "md") {
        const l = s.children[0], c = o[o.length - 1], a = r + 1 < e.length ? E(e[r + 1], t) : null, u = a?.name === "p" ? a.children : null;
        if (c?.name === "p")
          c.children.push(l), u && (c.children.push(
            ...u
          ), r += 1);
        else {
          const d = [l];
          u && (d.push(...u), r += 1), o.push(h("p", d));
        }
        continue;
      }
      if ((s.name === "ul" || s.name === "ol") && o.length > 0) {
        const l = o[o.length - 1];
        if (l?.name === "p") {
          l.children.push(s);
          continue;
        }
      }
      o.push(s);
    }
  }
  return n ? M(o) : o;
}
function he(e, t, n) {
  const o = se(
    n.topLevelDivision,
    e.depth
  ), r = h("title", x(e.children, n)), i = me(e, n), s = q(
    t,
    { ...n, depth: n.depth + 1 },
    !0
  ), l = M(s);
  return h(o, [r, ...l], i);
}
function de(e) {
  const t = e.data;
  return t?.id ? { "xml:id": t.id } : void 0;
}
function me(e, t) {
  const n = de(e), o = V(t);
  if (!(!n && !o))
    return { ...o, ...n };
}
function V(e) {
  if (e.depth !== 0) return;
  const t = e.topLevelAttributesApplied;
  if (!(!e.topLevelAttributes || !t || t.done))
    return t.done = !0, e.topLevelAttributes;
}
const ge = {
  paragraph: (e, t) => K(e, t),
  blockquote: (e, t) => ye(e, t),
  list: (e, t) => ve(e, t),
  code: (e, t) => be(e),
  containerDirective: (e, t) => Y(e, t)
};
function E(e, t) {
  const n = ge[e.type];
  return n ? n(e, t) : (t.messages && t.messages.push({
    type: "warning",
    reason: `Unknown block type: ${e.type}`,
    category: "unknown-block-type"
  }), X(
    "unknown-block-type",
    `unknown block type "${e.type}"`,
    $(e, t)
  ));
}
function K(e, t) {
  return h("p", x(e.children, t));
}
function ye(e, t) {
  const n = e.children.filter((o) => o.type === "paragraph").map((o) => {
    const r = {
      ...t,
      ancestors: [...t.ancestors, e],
      depth: t.depth + 1
    };
    return K(o, r);
  });
  return h("blockquote", n);
}
function ve(e, t) {
  const n = e.children.map((o) => {
    const r = {
      ...t,
      ancestors: [...t.ancestors, e],
      depth: t.depth + 1
    };
    return ke(o, r);
  });
  return h(e.ordered ? "ol" : "ul", n);
}
function ke(e, t) {
  const n = C(
    e.children,
    t
  );
  return h("li", n);
}
function be(e, t) {
  return g(
    "program",
    e.value,
    e.lang ? { language: e.lang } : void 0
  );
}
function xe(e, t) {
  const n = e.value.split(/\\\\|[\r\n]+/).map((o) => o.trim()).filter((o) => o.length > 0);
  return n.length > 1 ? h(
    "md",
    n.map((o) => g("mrow", o))
  ) : g("md", n[0] ?? "");
}
function De(e, t) {
  return e.meta === "inline" ? g("m", e.value) : xe(e);
}
function Y(e, t) {
  const n = ce(e.name);
  if (!n)
    return t.messages && t.messages.push({
      type: "warning",
      reason: `Unknown directive: ${e.name}`,
      category: "unknown-directive"
    }), X(
      "unknown-directive",
      `unknown directive "${e.name}"`,
      $(e, t)
    );
  const o = we(e), r = e.children, { title: i, body: s } = Ce(
    r,
    t
  ), l = {
    ...t,
    ancestors: [...t.ancestors, e],
    depth: t.depth + 1
  };
  return ue(
    n,
    o,
    i,
    s,
    l,
    (c, a) => E(c, a),
    (c, a) => Y(c, a)
  );
}
function Ce(e, t) {
  const n = e[0];
  return n?.type === "paragraph" && n.data?.directiveLabel === !0 ? {
    title: h(
      "title",
      x(n.children, t)
    ),
    body: e.slice(1)
  } : { title: null, body: e };
}
function we(e) {
  const t = e.attributes ?? {}, n = {};
  for (const [o, r] of Object.entries(t))
    r != null && (n[o === "id" ? "xml:id" : o] = r);
  return Object.keys(n).length > 0 ? n : void 0;
}
function Le(e, t) {
  return !t || e.position?.start?.offset === null || e.position?.start?.offset === void 0 ? "asterisk" : t.charAt(e.position.start.offset) === "_" ? "underscore" : "asterisk";
}
const Se = {
  text: (e, t) => U(e.value),
  emphasis: (e, t) => {
    const o = Le(e, t.source) === "underscore" ? "term" : "em";
    return h(o, x(e.children, t));
  },
  strong: (e, t) => h("alert", x(e.children, t)),
  inlineCode: (e, t) => g("c", e.value),
  math: (e, t) => De(e)
};
function x(e, t) {
  return e.flatMap((n) => Ie(n, t)).filter((n) => n !== null);
}
function Ie(e, t) {
  const n = Se[e.type];
  if (!n)
    return t.messages && t.messages.push({
      type: "warning",
      reason: `Unknown inline type: ${e.type}`,
      category: "unknown-inline-type"
    }), pe(
      "unknown-inline-type",
      `unknown inline type "${e.type}"`,
      $(e, t)
    );
  const o = { ...t, ancestors: [...t.ancestors, e] };
  return n(e, o);
}
const qe = [
  // Display math (check these first, before single $)
  { open: "$$", close: "$$", isDisplay: !0 },
  { open: "\\[", close: "\\]", isDisplay: !0 },
  // Inline math
  { open: "$", close: "$", isDisplay: !1 },
  { open: "\\(", close: "\\)", isDisplay: !1 }
], G = "PTX_MATH_TOKEN_", I = new RegExp(`${G}(\\d+)`, "g");
function J(e, t) {
  let n = null;
  for (const o of qe) {
    const r = e.indexOf(o.open, t);
    if (r === -1) continue;
    const i = e.indexOf(o.close, r + o.open.length);
    if (i !== -1 && !(o.open === "$" && (r > 0 && e[r - 1] === "$" || r + 1 < e.length && e[r + 1] === "$")) && (!n || r < n.index)) {
      const s = e.substring(r + o.open.length, i);
      n = { index: r, pattern: o, content: s };
    }
  }
  return n;
}
function Ee(e, t) {
  let n = t;
  for (; n < e.length; ) {
    const o = e.indexOf("`", n);
    if (o === -1) return null;
    let r = 0, i = o;
    for (; i < e.length && e[i] === "`"; )
      r++, i++;
    const s = "`".repeat(r);
    let l = i;
    for (; l < e.length; ) {
      const c = e.indexOf(s, l);
      if (c === -1) break;
      const a = c + r;
      if (a >= e.length || e[a] !== "`")
        return { start: o, end: a };
      l = c + 1;
    }
    n = o + r;
  }
  return null;
}
function Te(e) {
  const t = /* @__PURE__ */ new Map();
  let n = "", o = 0, r = 0;
  for (; o < e.length; ) {
    const i = Ee(e, o), s = J(e, o);
    if (i && (!s || i.start < s.index)) {
      n += e.substring(o, i.end), o = i.end;
      continue;
    }
    if (!s) {
      n += e.substring(o);
      break;
    }
    n += e.substring(o, s.index);
    const l = `${G}${r}`;
    n += l, t.set(l, {
      type: "math",
      value: s.content,
      meta: s.pattern.isDisplay ? "display" : "inline"
    }), o = s.index + s.pattern.open.length + s.content.length + s.pattern.close.length, r += 1;
  }
  return { markdown: n, tokens: t };
}
function Ae(e) {
  const t = [];
  let n = 0;
  for (; n < e.length; ) {
    const o = J(e, n);
    if (!o) {
      n < e.length && t.push({ type: "text", value: e.substring(n) });
      break;
    }
    o.index > n && t.push({
      type: "text",
      value: e.substring(n, o.index)
    }), t.push({
      type: "math",
      value: o.content,
      meta: o.pattern.isDisplay ? "display" : "inline"
    }), n = o.index + o.pattern.open.length + o.content.length + o.pattern.close.length;
  }
  return t.length === 0 ? [{ type: "text", value: e }] : t;
}
function $e(e, t) {
  const n = [];
  let o = 0;
  I.lastIndex = 0;
  let r = I.exec(e);
  for (; r; ) {
    const i = r.index, s = r[0];
    i > o && n.push({ type: "text", value: e.substring(o, i) });
    const l = t.get(s);
    l ? n.push(l) : n.push({ type: "text", value: s }), o = i + s.length, r = I.exec(e);
  }
  return o < e.length && n.push({ type: "text", value: e.substring(o) }), n.length === 0 ? [{ type: "text", value: e }] : n;
}
function Q(e) {
  W(e, "paragraph", (t) => {
    const n = t.children || [], o = [];
    for (const r of n)
      if (r.type === "text") {
        const i = Ae(r.value);
        o.push(...i);
      } else
        o.push(r);
    t.children = o;
  });
}
function Me(e, t) {
  W(e, "paragraph", (n) => {
    const o = n.children || [], r = [];
    for (const i of o)
      if (i.type === "text") {
        const s = $e(i.value, t);
        r.push(...s);
      } else
        r.push(i);
    n.children = r;
  });
}
const It = () => (e) => {
  Q(e);
};
function Fe(e) {
  const t = e.trim();
  if (!t.startsWith(":")) return null;
  let n = 0;
  for (let i = 0; i < t.length && t[i] === ":"; i++)
    n++;
  if (n < 3) return null;
  const o = t.slice(n).trim(), r = o.match(/^([a-zA-Z0-9_-]+)(\[[^\]]*\])?(\{[^}]*\})?$/);
  return o === "" ? { colons: n, label: null, lineIndex: -1, isOpen: !1 } : r ? { colons: n, label: r[0], lineIndex: -1, isOpen: !0 } : null;
}
function Ne(e) {
  const t = [], n = [];
  for (const o of e)
    if (o.isOpen) {
      const r = {
        colons: o.colons,
        finalColons: o.colons,
        label: o.label,
        openLineIndex: o.lineIndex,
        closeLineIndex: null,
        children: [],
        parent: null
      };
      if (t.length > 0) {
        const i = t[t.length - 1];
        r.parent = i, i.children.push(r);
      } else
        n.push(r);
      t.push(r);
    } else {
      const r = t[t.length - 1];
      r && r.colons === o.colons && (r.closeLineIndex = o.lineIndex, t.pop());
    }
  return n;
}
function ee(e) {
  if (e.children.length === 0)
    e.finalColons = e.colons;
  else {
    const t = Math.max(...e.children.map(ee));
    e.finalColons = Math.max(e.colons, t + 1);
  }
  return e.finalColons;
}
function Oe(e, t, n) {
  const o = e.slice(), r = [], i = t.slice();
  for (; i.length > 0; ) {
    const s = i.shift();
    r.push(s), i.push(...s.children);
  }
  for (const s of r) {
    if (s.openLineIndex >= 0) {
      const l = o[s.openLineIndex], c = l.match(/^:+/)?.[0].length || 3, a = l.slice(c);
      o[s.openLineIndex] = ":".repeat(s.finalColons) + a;
    }
    s.closeLineIndex !== null && s.closeLineIndex >= 0 && (o[s.closeLineIndex] = ":".repeat(s.finalColons));
  }
  return o;
}
function _e(e) {
  const t = e.split(`
`), n = [];
  let o = !1, r = null;
  for (let l = 0; l < t.length; l++) {
    const c = t[l], u = c.trim().match(/^(`{3,}|~{3,})/);
    if (u) {
      const m = u[1];
      o ? r && m[0] === r[0] && m.length >= r.length && (o = !1, r = null) : (o = !0, r = m);
      continue;
    }
    if (o)
      continue;
    const d = Fe(c);
    d && n.push({ ...d, lineIndex: l });
  }
  if (n.length === 0)
    return e;
  const i = Ne(n);
  for (const l of i)
    ee(l);
  return Oe(t, i).join(`
`);
}
function Re(e) {
  const t = e.trim();
  if (!t.endsWith(":")) return null;
  const n = t.slice(0, -1);
  if (!/^[a-zA-Z]/.test(n)) return null;
  const o = n.match(/^([a-zA-Z][a-zA-Z0-9_-]*)(.*)$/);
  if (!o) return null;
  const [, r, i] = o;
  return i && !/^(\[[^\]]*\]|\{[^}]*\})*$/.test(i) || !S[r.toLowerCase()] ? null : n;
}
function T(e) {
  let t = 0;
  for (let n = 0; n < e.length; n++)
    if (e[n] === " ")
      t += 1;
    else if (e[n] === "	")
      t += 4;
    else
      break;
  return t;
}
function Pe(e, t) {
  const n = T(e[t]);
  for (let o = t + 1; o < e.length; o++)
    if (!te(e[o]))
      return T(e[o]) > n;
  return !1;
}
function te(e) {
  return e.trim() === "";
}
function je(e, t) {
  let n = 0, o = 0;
  for (; o < e.length && n < t; )
    if (e[o] === " ")
      n++, o++;
    else if (e[o] === "	")
      n += 4, o++;
    else
      break;
  return e.slice(o);
}
function Be(e) {
  const t = e.split(`
`), n = [], o = {
    level: 0,
    openDirectives: [],
    inCodeFence: !1,
    codeFenceMarker: null
  };
  for (let r = 0; r < t.length; r++) {
    const i = t[r], s = i.trim(), l = T(i), c = s.match(/^(`{3,}|~{3,})/);
    if (c) {
      const u = c[1];
      o.inCodeFence ? o.codeFenceMarker && s.startsWith(o.codeFenceMarker) && (o.inCodeFence = !1, o.codeFenceMarker = null) : (o.inCodeFence = !0, o.codeFenceMarker = u), n.push(i);
      continue;
    }
    if (o.inCodeFence) {
      n.push(i);
      continue;
    }
    if (te(i)) {
      n.push("");
      continue;
    }
    const a = Re(s);
    if (a && Pe(t, r)) {
      for (; o.openDirectives.length > 0 && !(o.openDirectives[o.openDirectives.length - 1].indentLevel < l); ) {
        const y = o.openDirectives.pop();
        y && n.push(":".repeat(y.colonCount));
      }
      const u = a.match(/^([a-zA-Z][a-zA-Z0-9_-]*)(.*)/), d = u ? u[1].toLowerCase() + (u[2] || "") : a, m = o.openDirectives.length * 1 + 3;
      n.push(":".repeat(m) + d), o.openDirectives.push({
        label: d,
        indentLevel: l,
        colonCount: m,
        bodyBaseIndent: -1
      }), o.level = l;
    } else {
      for (; o.openDirectives.length > 0 && l <= o.openDirectives[o.openDirectives.length - 1].indentLevel; ) {
        const u = o.openDirectives.pop();
        u && n.push(":".repeat(u.colonCount));
      }
      if (o.openDirectives.length > 0) {
        const u = o.openDirectives[o.openDirectives.length - 1];
        u.bodyBaseIndent < 0 && (u.bodyBaseIndent = l), n.push(je(i, u.bodyBaseIndent));
      } else
        n.push(i);
      o.level = l;
    }
  }
  for (; o.openDirectives.length > 0; ) {
    const r = o.openDirectives.pop();
    r && n.push(":".repeat(r.colonCount));
  }
  return n.join(`
`);
}
const ze = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?/, We = /^division:\s*(\S+)\s*$/m, He = /^xmlid:\s*(\S+)\s*$/m, Ue = /^label:\s*(\S+)\s*$/m, Ze = /^component:\s*(\S+)\s*$/m;
function Xe(e) {
  const t = e.match(ze);
  if (!t)
    return { body: e };
  const n = t[1], o = e.slice(t[0].length), r = n.match(We)?.[1], i = r && le(r) ? r : void 0, s = {}, l = n.match(He)?.[1], c = n.match(Ue)?.[1], a = n.match(Ze)?.[1];
  return l && (s["xml:id"] = l), c && (s.label = c), a && (s.component = a), {
    division: i,
    attributes: Object.keys(s).length > 0 ? s : void 0,
    body: o
  };
}
const Ve = function(e) {
  return function(n, o) {
    if (typeof o?.value == "string") {
      const r = Xe(o.value), i = e?.topLevelDivision ?? r.division ?? "chapter", s = e?.topLevelAttributes ?? r.attributes, l = Be(r.body), c = _e(l), a = Te(c), d = j().data("micromarkExtensions", [{ disable: { null: ["codeIndented"] } }]).use(B).use(z).parse(a.markdown);
      return Me(d, a.tokens), O(d, a.markdown, {
        topLevelDivision: i,
        topLevelAttributes: s
      });
    }
    return Q(n), O(n, void 0, {
      topLevelDivision: e?.topLevelDivision ?? "chapter",
      topLevelAttributes: e?.topLevelAttributes
    });
  };
}, Ke = /["&'<>`]/g, Ye = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, Ge = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), Je = /[|\\{}()[\]^$+*?.]/g, _ = /* @__PURE__ */ new WeakMap();
function Qe(e, t) {
  if (e = e.replace(
    t.subset ? et(t.subset) : Ke,
    o
  ), t.subset || t.escapeOnly)
    return e;
  return e.replace(Ye, n).replace(Ge, o);
  function n(r, i, s) {
    return t.format(
      (r.charCodeAt(0) - 55296) * 1024 + r.charCodeAt(1) - 56320 + 65536,
      s.charCodeAt(i + 2),
      t
    );
  }
  function o(r, i, s) {
    return t.format(
      r.charCodeAt(0),
      s.charCodeAt(i + 1),
      t
    );
  }
}
function et(e) {
  let t = _.get(e);
  return t || (t = tt(e), _.set(e, t)), t;
}
function tt(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t.push(e[n].replace(Je, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
function nt(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function ot(e, t) {
  return Qe(e, Object.assign({ format: nt }, t));
}
const rt = /[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g;
function v(e, t, n) {
  const o = it(e);
  return n ? o.replace(n, r) : r(o);
  function r(i) {
    return ot(i, { subset: t });
  }
}
function it(e) {
  return String(e || "").replace(rt, "");
}
const st = /]]>/g, lt = [">"];
function ct(e) {
  return "<![CDATA[" + v(e.value, lt, st) + "]]>";
}
function at(e) {
  return "<!--" + v(e.value, ["-"]) + "-->";
}
const ut = ["	", `
`, " ", '"', "&", "'", "/", "<", "=", ">"];
function L(e) {
  return v(e, ut);
}
function R(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let o = 0, r = n.indexOf(t);
  for (; r !== -1; )
    o++, r = n.indexOf(t, r + t.length);
  return o;
}
function A(e, t) {
  const n = String(e);
  let o = t.options.quote || '"';
  if (t.options.quoteSmart) {
    const r = o === '"' ? "'" : '"';
    R(n, o) > R(n, r) && (o = r);
  }
  return o + v(n, ["<", "&", o]) + o;
}
function pt(e, t) {
  const n = L(e.name), o = e.public, r = e.system;
  let i = "<!DOCTYPE";
  return n !== "" && (i += " " + n), o ? i += " PUBLIC " + A(o, t) : r && (i += " SYSTEM"), r && (i += " " + A(r, t)), i + ">";
}
const ft = {}.hasOwnProperty;
function ht(e, t) {
  const n = L(e.name), o = re(e, t), r = e.attributes || {}, i = o ? !1 : t.options.closeEmptyElements, s = [];
  let l;
  for (l in r)
    if (ft.call(r, l)) {
      const c = r[l];
      c != null && s.push(L(l) + "=" + A(c, t));
    }
  return "<" + n + (s.length === 0 ? "" : " " + s.join(" ")) + (i ? (t.options.tightClose ? "" : " ") + "/" : "") + ">" + o + (i ? "" : "</" + n + ">");
}
const dt = /\?>/g, mt = [">"];
function gt(e) {
  const t = L(e.name) || "x", n = v(e.value, mt, dt);
  return "<?" + t + (n ? " " + n : "") + "?>";
}
const yt = ["&", "<"];
function ne(e) {
  return v(e.value, yt);
}
function vt(e, t) {
  return t.options.allowDangerousXml ? e.value : ne(e);
}
const kt = {}.hasOwnProperty, P = {
  cdata: ct,
  comment: at,
  doctype: pt,
  element: ht,
  instruction: gt,
  raw: vt,
  root: re,
  text: ne
};
function oe(e, t) {
  const n = e && e.type;
  if (!n)
    throw new Error("Expected node, not `" + e + "`");
  if (!kt.call(P, n))
    throw new Error("Cannot compile unknown node `" + n + "`");
  const o = P[n];
  return o(e, t);
}
function re(e, t) {
  const n = e && e.children || [];
  let o = -1;
  const r = [];
  for (; ++o < n.length; )
    r[o] = oe(n[o], t);
  return r.join("");
}
function bt(e, t) {
  const n = { options: {} };
  if (typeof n.options.quote == "string" && n.options.quote !== '"' && n.options.quote !== "'")
    throw new Error(
      "Invalid quote `" + n.options.quote + "`, expected `'` or `\"`"
    );
  const o = Array.isArray(e) ? { type: "root", children: e } : e;
  return oe(o, n);
}
function qt(e, t) {
  const n = j().use(B).use(z).use(Ve, t), o = n.parse(e), r = n.runSync(o, { value: e });
  return bt(r.children);
}
export {
  St as DIRECTIVE_MAP,
  H as PROOF_SOLUTION_NAMES,
  qt as markdownToPretext,
  O as mdastToPtxast,
  It as remarkMath,
  Ve as remarkPretext
};
